import { Box, Flex, Text } from '@chakra-ui/react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

type TProps = {
    children: string;
    href: string;
};

const BackButton = ({ children, href }: TProps) => (
    <Flex gap="16px" alignItems="center" as={Link} mb="40px" mt="-88px" to={href}>
        <Flex
            border="1px"
            borderColor="gray.200"
            width="48px"
            height="48px"
            alignItems="center"
            justifyContent="center"
            borderRadius="12px"
        >
            <IoMdArrowRoundBack />
        </Flex>
        <Text fontSize="md" fontWeight="500" color="gray.900">
            {children}
        </Text>
    </Flex>
);

export default BackButton;
